import mark from "./mark.json";
import React, {
  type SVGProps,
  type HTMLAttributes,
  type ImgHTMLAttributes,
} from "react";

export function BrandMark(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={mark.viewBox}
      fill="currentColor"
      aria-hidden="true"
      {...props}
      className={`method-mark ${props.className ?? ""}`}
    >
      {mark.paths.map((d, i) => (
        <path key={i} d={d} />
      ))}
    </svg>
  );
}
export function Wordmark(props: HTMLAttributes<HTMLSpanElement>) {
  return (
    <span {...props} className={`method-wordmark ${props.className ?? ""}`}>
      <BrandMark />
      Method.
    </span>
  );
}
export const artwork = {
  steps: {
    src: "/brand/art-steps.webp",
    width: 1774,
    height: 887,
    alt: "Orange and blue steps rise toward a circle on warm paper.",
  },
  workshop: {
    src: "/brand/art-workshop.webp",
    width: 1774,
    height: 887,
    alt: "Interlocking geometric forms in warm printed colors.",
  },
  rhythm: {
    src: "/brand/art-rhythm.webp",
    width: 1774,
    height: 887,
    alt: "Overlapping orange, pink, and blue arcs on warm paper.",
  },
} as const;
export type Artwork = keyof typeof artwork;
/** Keep intrinsic proportions. Use a separate composition for a new format. */
export function BrandImage({
  kind,
  ...props
}: ImgHTMLAttributes<HTMLImageElement> & { kind: Artwork }) {
  return (
    <img
      {...artwork[kind]}
      loading="lazy"
      {...props}
      className={`method-art ${props.className ?? ""}`}
    />
  );
}

export { ProductEmail } from "./email";
